import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * 网络状态管理存储
 * 用于跟踪应用的网络连接状态和后端服务可用性
 */
export const useNetworkStore = defineStore('network', () => {
  // 是否在线
  const isOnline = ref(navigator.onLine);
  
  // 后端服务是否可用
  const isBackendAvailable = ref(true);
  
  // 最后一次检查时间
  const lastCheckTime = ref(Date.now());
  
  // 网络错误信息
  const networkError = ref(null);
  
  // 设置在线状态
  function setOnline(status) {
    isOnline.value = status;
    lastCheckTime.value = Date.now();
  }
  
  // 设置后端服务可用状态
  function setBackendAvailable(status) {
    isBackendAvailable.value = status;
    lastCheckTime.value = Date.now();
  }
  
  // 设置网络错误信息
  function setNetworkError(error) {
    networkError.value = error;
    lastCheckTime.value = Date.now();
    
    // 如果是服务器错误，标记后端不可用
    if (error && (error.type === 'server' || error.type === 'connection')) {
      isBackendAvailable.value = false;
    }
    
    // 2秒后自动清除错误信息
    setTimeout(() => {
      networkError.value = null;
    }, 2000);
  }
  
  // 清除网络错误信息
  function clearNetworkError() {
    networkError.value = null;
  }
  
  // 重新连接计数
  const reconnectCount = ref(0);
  
  // 增加重连计数
  function incrementReconnectCount() {
    reconnectCount.value += 1;
  }
  
  // 重置重连计数
  function resetReconnectCount() {
    reconnectCount.value = 0;
  }
  
  return {
    isOnline,
    isBackendAvailable,
    lastCheckTime,
    networkError,
    reconnectCount,
    setOnline,
    setBackendAvailable,
    setNetworkError,
    clearNetworkError,
    incrementReconnectCount,
    resetReconnectCount
  };
}); 